import { DocUserInterface } from '../interfaces/doc-user.interface';

export class Group {
  /**
   * Id.
   */
  public id: number;

  /**
   * Name.
   */
  public name: string;

  /**
   * Color.
   */
  public color?: string;

  /**
   * Members.
   */
  public members: DocUserInterface[];

  /**
   * Disabled.
   */
  public disabled = false;

  /**
   * Group constructor.
   *
   *
   * @param data Group.
   */
  constructor(data: Group) {
    this.id = data.id;
    this.name = data.name;
    this.color = data.color;
    this.members = data.members;
    this.disabled = data.disabled;
  }
}
